<template>
    <div style="height: 100%">
        <v-card style="height: 100%">
            <v-toolbar
                height="70"
                outlined
                flat
            >
                Medidores 
                <v-spacer></v-spacer>
                <v-btn color="accent" :disabled="!changes" @click="save">
                    <v-icon>mdi-content-save</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="10">
                        <v-autocomplete
                            :items="meters"
                            :filter="filter"
                            solo
                            hide-details
                            color="white"
                            item-text="circuit"
                            item-value="name"
                            label="Nombre de medidor"
                            v-model="selected"
                        ></v-autocomplete>
                    </v-col>
                    <v-col class="d-flex align-center" cols="12" md="2">
                        <v-btn block color="accent" @click="addMeter">Añadir</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pt-0">
                        <v-simple-table fixed-header> 
                                <thead>
                                    <tr>
                                        <th class="text-left">Medidor</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody v-if="metersOnSchedule.length > 0">
                                    <tr v-for="meter in metersOnSchedule" :key="meter.name">
                                        <td>{{ meter.circuit }}</td>
                                        <th class="text-right">
                                            <v-btn icon @click="deleteMeter(meter.name)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </th>
                                    </tr>
                                </tbody>
                                <v-card-text v-else class="text-center empty">
                                    <v-icon large>
                                        mdi-inbox
                                    </v-icon>
                                    <p>No hay medidores añadidos</p>
                                </v-card-text>
                        </v-simple-table>
                    </v-col>
                </v-row>
                
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    name:'info',
    props: ['schedule'],
    computed:{
        ...mapState({
            meters: state => state.meters.meters
        }),
    },
    data() {
        return {
            selected: null,
            metersOnSchedule: [],
            changes: false
        }
    },
    methods:{
        ...mapActions({ 
            addGateways: 'schedules/updateScheduleGateways'
        }),
        filter(item, queryText, itemText) {
            const name = item.name.toLowerCase()
            const circuit = item.circuit.toLowerCase()
            const searchText = queryText.toLowerCase()

            return name.indexOf(searchText) > -1 ||
            circuit.indexOf(searchText) > -1
        
        },
        addMeter(){
            if(!this.selected) return
            
            let meter = this.meters.find(m => m.name == this.selected)
            
            let alreadyAdd = this.metersOnSchedule.find(m => m.gateway.id == meter.gateway.id)
            if(alreadyAdd) return

            this.metersOnSchedule.push(meter)
            this.changes = true
        },
        deleteMeter(meter){
            let index = this.metersOnSchedule.findIndex( m => m.name == m.name)
            this.metersOnSchedule.splice(index, 1);
            this.changes = true
        },
        async save(){
            try {
                await this.addGateways({
                    schedule: this.schedule.id,
                    gateways: this.metersOnSchedule.map( m => ({name: m.gateway.id, key: m.gateway.key}))
                })
                this.changes = false
            } catch (error) {
                console.log(error)
            }
        },
        setMeterOnSchedule(){
            this.metersOnSchedule = this.schedule.gateways.map( g => {
                return this.meters.find( m => m.gateway.id == g.name)
            })
        }
    },
    watch:{
        schedule(){
            this.setMeterOnSchedule()
        }
    },
    mounted(){
        this.setMeterOnSchedule()
    }
}
</script>

<style scoped>
.empty{
    margin-top: 18%;
}
</style>